import * as api from '../../../api/department/departmentApi';
import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  // CREATE_DEPARTMENT,
  // UPDATE_DEPARTMENT,
  // DELETE_DEPARTMENT,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE
} from '../../types/department/departmentTypes';

export const fetchDepartments = () => async (dispatch) => {
  dispatch({ type: FETCH_DEPARTMENTS_REQUEST });
  try {
    const response = await api.fetchDepartments();
    dispatch({ type: FETCH_DEPARTMENTS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch departments';
    dispatch({ type: FETCH_DEPARTMENTS_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createDepartment = (data) => async (dispatch) => {
  dispatch({ type: CREATE_DEPARTMENT_REQUEST });
  try {
    const response = await api.createDepartment(data);
    const newDepartment = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_DEPARTMENT_SUCCESS, payload: newDepartment });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create department';
    dispatch({ type: CREATE_DEPARTMENT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const updateDepartment = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_DEPARTMENT_REQUEST });
  try {
    const response = await api.updateDepartment(id, data);
    dispatch({ type: UPDATE_DEPARTMENT_SUCCESS, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update department';
    dispatch({ type: UPDATE_DEPARTMENT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const deleteDepartment = (id) => async (dispatch) => {
  dispatch({ type: DELETE_DEPARTMENT_REQUEST });
  try {
    const response = await api.deleteDepartment(id);
    dispatch({ type: DELETE_DEPARTMENT_SUCCESS, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete department';
    dispatch({ type: DELETE_DEPARTMENT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};
